import { upperFirst } from 'lodash'

import { isEmpty, proxy } from '@/utils'

import render from './render'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'object' }) ],

    computed: {
      $_disabled() {
        return Boolean(this.disabled || isEmpty(this.proxy) && !this.proxyIsChanged || !this.proxyIsChanged || options.loading.update[options.path])
      }
    },

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
